import React, { Component } from 'react'
import { Prompt, withRouter } from 'react-router-dom'
import {
  getStepByIndex,
  getStepIndexByUrl,
  updateDBStepProgress,
  updateStepProgress } from '../../helpers/steps'
import DrupalModal from '../tags/Modals/DrupalModal'
import {
  getChoiceLinesParent,
  getSonePersonalDetails,
  getStudyPeriodsCodesDescription,
  getStudentProgress,
  putStudentPatternOfStudy,
  updateEnrolment } from '../../services/vu'
import { getCourseId } from '../../helpers/course'
import { unitLocationStartDate, unitWithdrawalDate } from '../../helpers/unitDropDateHelper'
import Sidenote from '../tags/Sidenote'
import {
  addVirtualUnits,
  getActiveEnrolledDualInstanceCalendarTypeUnits,
  getActiveEnrolledSingleInstanceCalendarTypeUnits,
  getAttributeCourseStaticInfo,
  getEnrolledUnits,
  getFlattenedUnitsWithMultipleAttendanceModes,
  getUnitsWithMultipleAttendanceModes,
  hasDuplicates,
  isStudentOnLeave,
  removeVirtualUnitsOverlappingRealUnits
} from '../../helpers/enrolment'
import EnrolmentGuide from '../tags/EnrolmentGuide'
import EnrolmentContainer from '../tags/EnrolmentContainer'
import UnitSelectionInstructions from '../tags/UnitSelectionInstructions'
import { differenceInSeconds, differenceInYears } from 'date-fns'
import { getLastPageAccessTime } from '../../helpers/gtm'
import ErrorModal from '../tags/Modals/ErrorModal'
import { getConfiguration } from '../../helpers/configuration'
import UnitStatus from '../../enums/UnitStatus'
import UnitStage from '../../enums/UnitStage'
import BlockType from '../../enums/BlockType'
import PatternAssociationStatus from '../../enums/PatternAssociationStatus'
import Loading from '../tags/Loading'
import ChoiceLines from '../tags/ChoiceLines/ChoiceLines'
import { processUnitAddErrors } from '../../helpers/errors'
import { Info } from '@mui/icons-material'
import { CustomModal } from '../tags/Modals/Modal'

class Units extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentEnrolment: [],
      enrolledUnits: [],
      coursePatternId: null,
      patternStatus: '',
      submitting: false,

      loadingUnits: false,
      hasBlockStatus: false,

      showInfoModal: false,
      showDropDatePassedConfirmationModal: false,
      dropDateSubmissionConfirmation: false,
      choiceLinesParent: [],

      studyPackages: [],
      loadingEnrolmentGuide: false,

      strictPatternStudent: false,

      blockCode: '',
      availabilityYear: '',
      prefillAttemptSuccessful: false,
      admissionCategory: '',
      isLoadingProgress: true,
      progress: null,
      requiresEnrolmentGuide: false,
      personalDetails: null,
      apiCallFailed: false,
      unspecifiedAdvanceStandingFlag: '',
      enrolmentApiFailed: false,
      reloadEnrolmentGuide: false,
      reloadChoiceLineParents: false,
      reOpenModal: false,
      openEnrolmentErrorModel: false,
      enrolmentErrors: [],
      enrolmentErrorsPartialSuccess: false,
      unitsRemoved: [],
      studyPeriods: []
    }
  }

  componentDidMount() {
    this.setState({
      loadingUnits: true
    })

    this.getPrefillUnits()

    Promise.allSettled([getSonePersonalDetails(), getStudentProgress(getCourseId()), getStudyPeriodsCodesDescription()])
      .then(([personalDetails, studentProgress, studyPeriods]) => {
        let newState = {
          isLoadingProgress: false
        }

        if (studentProgress.status === 'fulfilled') {
          newState = {
            ...newState,
            progress: studentProgress.value
          }
        }

        if (studyPeriods.status === 'fulfilled') {
          newState = {
            ...newState,
            studyPeriods: studyPeriods.value.referenceCodes,
          }
        }

        if (personalDetails.status === 'fulfilled') {
          newState = {
            ...newState,
            personalDetails: personalDetails,
          }
        }

        this.setState({
          ...newState
        })
      })

    window.addEventListener('beforeunload', this.displayUnconfirmedOrRemovedUnitsWarning)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.reloadEnrolmentGuide && !prevState.reloadEnrolmentGuide) {
      this.initialiseEnrolledUnits()
    } else if (this.state.reloadChoiceLineParents && !prevState.reloadChoiceLineParents) {
      this.setState({
        loadingUnits: true
      })
      Promise.all([
        getChoiceLinesParent(getAttributeCourseStaticInfo('parentSSPNo'), getAttributeCourseStaticInfo('enrolmentYears')[0]),
        getEnrolledUnits(getAttributeCourseStaticInfo('parentSSPNo'), this.state.coursePatternId, this.state.patternStatus)
      ])
        .then(([choiceLineParentResponse, units]) => {
          this.setState({
            loadingUnits: true,
            reloadChoiceLineParents: false,
            choiceLinesParent: choiceLineParentResponse.information,
            ...this.processEnrolledUnitsCall(units)
          })
        })
        .catch(() => {
          this.setState({
            loadingUnits: false,
            reloadChoiceLineParents: false,
            apiCallFailed: true
          })
        })
    }
  }

  onEnrolmentUpdated = () => {
    this.setState({
      submitting: false,
      reloadChoiceLineParents: true
    })
  }

  getPrefillUnits = () => {
    putStudentPatternOfStudy(getAttributeCourseStaticInfo('parentSSPNo'), getAttributeCourseStaticInfo('enrolmentYears')[0])
      .then(response => {
        this.setState({
          availabilityYear: response.academicYear,
          coursePatternId: response.patternId,
          patternStatus: response.associationStatus,
          strictPatternStudent: response.strictPatternFlag === 'Y',
          prefillAttemptSuccessful: response.associationStatus === PatternAssociationStatus.MANUALLYASSOCIATED || response.associationStatus === PatternAssociationStatus.ASSOCIATED,
          requiresEnrolmentGuide: response.patternId === '',
          unspecifiedAdvanceStandingFlag: response.unspecifiedAdvanceStandingFlag
        }, () => {
          this.initialiseEnrolledUnits()
          getChoiceLinesParent(getAttributeCourseStaticInfo('parentSSPNo'), getAttributeCourseStaticInfo('enrolmentYears')[0]).then(choiceLinesParent => {
            this.setState({
              choiceLinesParent: choiceLinesParent.information
            })
          })
        })
      })
      .catch(() => {
        this.setState({
          loadingUnits: false,
          apiCallFailed: true
        })
        //TODO errors give an errror on screen
      })
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.displayUnconfirmedOrRemovedUnitsWarning)
  }

  processEnrolledUnitsCall = units => {
    let unitSet = []
    if (getAttributeCourseStaticInfo('blockCode') === BlockType.FourWeekBlock || getAttributeCourseStaticInfo('blockCode') === BlockType.EightWeekBlock) {
      let virtualUnitSet = addVirtualUnits(units)
      unitSet = removeVirtualUnitsOverlappingRealUnits(virtualUnitSet)
    } else {
      unitSet = units
    }
    return {
      currentEnrolment: Array.from(unitSet),
      enrolledUnits: unitSet,
      loadingUnits: false,
      defaultLocation: getAttributeCourseStaticInfo('locationCode'),
      admissionCategory: getAttributeCourseStaticInfo('admissionCategory'),
      blockCode: getAttributeCourseStaticInfo('blockCode'),
      courseTitle: getAttributeCourseStaticInfo('courseTitle'),
      courseCode: getAttributeCourseStaticInfo('courseCode')
    }
  }

  reloadChoiceLineParents = (reOpenModal = false) => {
    getChoiceLinesParent(getAttributeCourseStaticInfo('parentSSPNo'), getAttributeCourseStaticInfo('enrolmentYears')[0])
      .then(choiceLineParentResponse => {
        this.setState({
          choiceLinesParent: choiceLineParentResponse.information,
          reloadEnrolmentGuide: true,
          reOpenModal: reOpenModal
        })
      })
      .catch(() => {
        this.setState({
          apiCallFailed: true,
          reloadEnrolmentGuide: true,
          reOpenModal: reOpenModal
        })
      })
  }

  getProcessId = () => (this.state.progress && this.state.progress.id ? this.state.progress.id : undefined)

  trackPageView = () => {
    const lastPageAccessTime = getLastPageAccessTime()
    const pageAccessTime = new Date()

    window.dataLayer.push({
      event: 'custom.form.step.view',
      group: 'Enrol',
      processId: this.getProcessId(),
      step: {
        sequence: 4,
        label: 'Enrol in your units',
        variation: undefined
      },
      info: {
        time: lastPageAccessTime ? differenceInSeconds(pageAccessTime, new Date(lastPageAccessTime)) : undefined
      },
      data: {
        value: undefined,
        courseId: getCourseId()
      }
    })

    sessionStorage.setItem('LAST_PAGE_ACCESS_TIME', JSON.stringify(pageAccessTime))
  }

  /**
   * @returns {Array}
   */
  getEnrolledUnits = () => {
    // VO-70: If a student has the "forced location" flag set in VU Connect,
    // filter out enrolled units with locations not associated with the
    // student's default campus location.
    //    if (this.state.forcedLocation) {
    //      return this.state.enrolledUnits.filter(
    //        unit => unit.locationCd === this.state.defaultLocation
    //      )
    //    }

    return this.state.enrolledUnits
  }

  hasUnconfirmedUnits = () => {
    return this.getEnrolledUnits().some(unit => {
      return unit.unitStatus === UnitStatus.PLANNED
    })
  }

  displayUnconfirmedOrRemovedUnitsWarning = event => {
    if (this.hasUnconfirmedUnits()) {
      event.returnValue = this.getUnconfirmedNavigateAwayText()
      return this.getUnconfirmedNavigateAwayText()
    }
    if (this.hasRemovedUnits()) {
      event.returnValue = this.getRemovedNavigateAwayText()
      return this.getRemovedNavigateAwayText()
    }
  }

  /**
   * Dispatch error to the screen.
   * @param {*} errorText error message.
   */
    dispatchEnrolmentErrorModel = (enrolmentErrors =[], partialSuccess = false, unitsRemoved = []) => {
      this.setState({
        submitting: false,
        loadingUnits: false,
        openEnrolmentErrorModel: true,
        enrolmentErrors: enrolmentErrors,
        enrolmentErrorsPartialSuccess: partialSuccess,
        unitsRemoved: unitsRemoved
      })
      // alert(errorText)
      // this.handleCloseSuggestionModal()
    }

    /**
   * Handle closing of the suggestion modal.
   */
    handleCloseEnrolmentErrorModal = (enrolmentUpdating = false) => {
      this.setState({
        openEnrolmentErrorModel: false
      })

      if (this.state.enrolmentErrorsPartialSuccess) {
        this.initialiseEnrolledUnits(this.state.unitsRemoved)
      }
    }

  getUnconfirmedNavigateAwayText = () => {
    return `You have unconfirmed units in your enrolment. Please click '${this.getSubmitButtonText()}' to confirm your enrolment before exiting.`
  }

  getRemovedNavigateAwayText = () => {
    return `You have removed units in your enrolment. Please click '${this.getSubmitButtonText()}' to confirm your enrolment before exiting.`
  }

  getSubmitButtonText = () => {
    return 'Submit enrolment'
  }

  initialiseEnrolledUnits = (removedUnits = []) => {
    this.setState({
      loadingUnits: true
    })
    getEnrolledUnits(getAttributeCourseStaticInfo('parentSSPNo'), this.state.coursePatternId, this.state.patternStatus).then(units => {
      let unitSet = []
      if (getAttributeCourseStaticInfo('blockCode') === BlockType.FourWeekBlock || getAttributeCourseStaticInfo('blockCode') === BlockType.EightWeekBlock) {
        let virtualUnitSet = addVirtualUnits(units)
        unitSet = removeVirtualUnitsOverlappingRealUnits(virtualUnitSet)
      } else {
        unitSet = units
      }

      if (removedUnits) {
        unitSet.map(unit => {
          unit.removed = removedUnits.includes(unit.spkNumber +"-" +unit.unitCode)
          return unit
        })
      }

      this.setState({
        currentEnrolment: Array.from(unitSet),
        enrolledUnits: unitSet,
        loadingUnits: false,
        defaultLocation: getAttributeCourseStaticInfo('locationCode'),
        admissionCategory: getAttributeCourseStaticInfo('admissionCategory'),
        blockCode: getAttributeCourseStaticInfo('blockCode')
      })
    })
  }

  handleUpdatingUnits = (isLoadingUnits = false) => {
    this.setState({
      loadingUnits: isLoadingUnits
    })
  }

  handleInfoCloseModal = () => {
    this.setState({
      showInfoModal: false
    })
  }

  handleDropDateCloseModal = () => {
    this.setState({
      showDropDatePassedConfirmationModal: false,
      submitting: false
    })
  }

  /**
   * Get all the enrolled units that have not been discontinued.
   *
   * @return {Array}
   */
  getActiveEnrolledUnits = () =>
    this.getEnrolledUnits().filter(
      unit =>
        (unit.unitStatus === UnitStatus.PLANNED && unit.unitStage === UnitStage.PLANNED) ||
        (unit.unitStatus === UnitStatus.ENROLLED && unit.unitStage === UnitStage.ENROLLED) ||
        (unit.unitStatus === UnitStatus.PASS && unit.unitStage === UnitStage.COMPLETED) ||
        (unit.unitStatus === UnitStatus.FAIL && unit.unitStage === UnitStage.COMPLETED)
    )

  getValidationErrors = () => {
    return this.getHasDuplicateEnrolledUnits()
  }

  /**
   * Checks the student's enrolment to see if they have double-upped an
   * enrolment for a particular block model calendar type, e.g. SEM-1-B1.
   *
   * @return {boolean}
   */
  getHasDoubleUppedBlockUnits = (calendarType = 'FourWeek', attendanceModeCheck) => {
    // Creates a array of strings from the actively enrolled block model units
    // into the following pattern:
    //
    // 2018-SEM-1-B1
    // 2018-SEM-1-B2
    //
    // If there is a duplicate string in the array for Four week or more than two for eight week blocks
    //  then we have more units enrolled than allowed into the respective block model period.
    const enrolledUnits =
      calendarType === 'FourWeek'
        ? getActiveEnrolledSingleInstanceCalendarTypeUnits(this.getActiveEnrolledUnits())
        : getActiveEnrolledDualInstanceCalendarTypeUnits(this.getActiveEnrolledUnits())
    const filteredSameBlockUnits = attendanceModeCheck
      ? enrolledUnits.filter(unit => unit.virtual !== true)
      : getFlattenedUnitsWithMultipleAttendanceModes(enrolledUnits.filter(unit => unit.virtual !== true))
    const unitCalendarArray = filteredSameBlockUnits.map(unit => `${unit.unitAvailabilityYear}-${unit.unitAvailabilityStudyPeriodCode}`)
    let maxInstances = calendarType === 'FourWeek' ? 1 : 2
    return hasDuplicates(unitCalendarArray, maxInstances)
  }

  dropDatePassed = () => {
    return this.getActiveEnrolledUnits().some(
      unit =>
        (unit.unitStatus === UnitStatus.PLANNED || unit.unitStatus === UnitStatus.ENROLLED) &&
        new Date(unitWithdrawalDate(unit)) < unitLocationStartDate(unit) &&
        new Date(unitWithdrawalDate(unit)) <= new Date()
    )
  }

  getHasDuplicateEnrolledUnits = () => {
    const enrolledUnits = this.getMutableUnits()
      // VUS-65: Enable repeating research units
      //TODO check repeatable indicator
      //      .filter(({ repeatableInd }) => repeatableInd !== 'Y')
      .filter(({ virtual }) => virtual !== true)
      .map(unit => unit.unitCode)

    const filteredSameBlockUnits = getFlattenedUnitsWithMultipleAttendanceModes(this.getMutableUnits().filter(unit => unit.virtual !== true)).map(unit => unit.unitCode)

    return hasDuplicates(filteredSameBlockUnits)
  }

  handleSubmit = () => {
    this.setState(
      {
        submitting: true
      },
      () => {
        if (this.getHasDoubleUppedBlockUnits('FourWeek', false) || this.getHasDoubleUppedBlockUnits('EightWeek', false)) {
          this.handleSubmissionError(
            'Your enrolment has more than one unit in one 4 Week Teaching Block and/or more ' +
              'than two units in one 8 Week Teaching Block. Please review your enrolment. For any assistance contact VUHQ.'
          )
          return
        }

        const unitsWithMultipleAttendanceModes = getUnitsWithMultipleAttendanceModes(
          this.getActiveEnrolledUnits().filter(unit => unit.unitStatus === UnitStatus.PLANNED && unit.virutal !== true)
        )

        if (unitsWithMultipleAttendanceModes.length > 0) {
          this.handleSubmissionError('You will need to select delivery for the following units before you can submit your enrolment: ' + unitsWithMultipleAttendanceModes.join())
          return
        }

        // Stop processing the form if we have duplicate unit codes in our
        // enrolment
        if (this.getHasDuplicateEnrolledUnits()) {
          this.handleSubmissionError('Please ensure that you have not selected the same unit more than once.')
          return
        }

        if (this.dropDatePassed() && !this.state.dropDateSubmissionConfirmation) {
          this.setState({
            showDropDatePassedConfirmationModal: true
          })
          return
        }
        const unitsToBeSubmitted = this.state.enrolledUnits.filter(unit => unit.unitStatus === UnitStatus.PLANNED && unit.removed !== true && unit.virtual !== true && unit.unitAvailabilityQuotaRemaining > 0)

        const payload = {
          courseCode: getAttributeCourseStaticInfo('courseCode'),
          courseVersion: getAttributeCourseStaticInfo('versionNumber'),
          courseAttemptNumber: getAttributeCourseStaticInfo('attemptNumber'),
          patternId: this.state.coursePatternId,
          patternStatus: this.state.patternStatus,
          parentSspNo: getAttributeCourseStaticInfo('parentSSPNo'),
          academicYear: this.state.availabilityYear,
          units: unitsToBeSubmitted
        }

        this.trackBigPayload(payload, 'custom.form.submit')

        updateEnrolment(payload)
          .then(() => {
            //progress if 200 response
            this.trackBigPayload(payload, 'custom.form.complete')
            this.progressForm()
          })
          .catch(error => {
            let responseData = error.response.data
            
            const unitsRemoved = this.state.enrolledUnits
              .filter(unit => unit.unitStatus === UnitStatus.PLANNED && unit.removed === true)
              .map(unit =>  unit.spkNumber +"-" +unit.unitCode)

            this.dispatchEnrolmentErrorModel(error.response.data.unitErrors, responseData.partialSuccess, unitsRemoved)
          })
      }
    )
  }

  trackBigPayload = (payload, payloadStage) => {
    const units = payload.units.map(unit => {
      return {
        id: unit.unitCode,
        location: unit.locationDescription,
        code: unit.unitAvailabilityStudyPeriodCode
      }
    })

    getSonePersonalDetails().then(personalDetails => {
      window.dataLayer.push({
        event: payloadStage,
        group: 'Enrol',
        processId: this.getProcessId(),
        info: {
          time: differenceInSeconds(new Date(), new Date(this.state.progress.lastUpdatedAt))
        },
        data: {
          value: undefined,
          courseId: getCourseId(),
          referenceId: undefined,
          units: units,
          age: differenceInYears(new Date(), new Date(personalDetails.dateOfBirth)) >= 18 ? '18+' : 'unknown',
          gender: this.calculateGender(personalDetails.gender),
          cspAndHelp: undefined,
          saHelp: undefined
        }
      })
    })
  }

  calculateGender = gender => {
    switch (gender) {
      case 'M':
        return 'Male'
      case 'F':
        return 'Female'
      default:
        return 'unknown'
    }
  }

  handleSubmissionError = errorMessage => {
    this.setState({
      submitting: false
    })
    alert(errorMessage)
    this.initialiseEnrolledUnits()
  }

  getMutableUnits = () => {
    return this.getActiveEnrolledUnits().filter(
      unit =>
        (unit.unitStatus === UnitStatus.PLANNED && unit.unitStage === UnitStage.PLANNED) ||
        (unit.unitStatus === UnitStatus.ENROLLED && unit.unitStage === UnitStage.ENROLLED) ||
        (unit.unitStatus === UnitStatus.PASS && unit.unitStage === UnitStage.COMPLETED)
    )
  }

  progressForm = () => {
    const currentStepIndex = getStepIndexByUrl(this.props.location.pathname)

    updateStepProgress(currentStepIndex)
    updateDBStepProgress(currentStepIndex)

    this.props.history.push(this.getNextPageUrl())
  }

  getNextPageUrl = () => {
    const currentStepIndex = getStepIndexByUrl(this.props.location.pathname)

    return getStepByIndex(currentStepIndex + 1).url
  }

  getIsBlockStatusStudent = () => this.state.blockCode === BlockType.FourWeekBlock || this.state.blockCode === BlockType.EightWeekBlock

  changeUnitUndoState = (unit, isRemoved) => {
    let enrolledUnits = this.state.enrolledUnits
    //using common method
    //TODO change prereq as no preresq is required
    enrolledUnits.forEach(enrolledUnit => {
      if (
        enrolledUnit.unitAvailabilityStudyPeriodCode === unit.unitAvailabilityStudyPeriodCode &&
        enrolledUnit.unitAvailabilityYear === unit.unitAvailabilityYear &&
        enrolledUnit.unitCode === unit.unitCode
      ) {
        enrolledUnit.removed = isRemoved
      }
    })

    this.setState({
      enrolledUnits: enrolledUnits
    })
  }

  hasRemovedUnits = () => {
    let removedUnit = this.state.enrolledUnits.some(unit => unit.removed)
    return removedUnit
  }

  getRemovedUnits = () => {
    let removedUnits = this.state.enrolledUnits.filter(unit => unit.removed === true)
    return removedUnits
  }

  isLoadingPrefillUnits = () => {
    return !this.state.loadingUnits
  }

  submitDropDateConfirmation = () => {
    this.setState({
      dropDateSubmissionConfirmation: true,
      showDropDatePassedConfirmationModal: false
    })
    this.handleSubmit()
  }

  handleChooseDeliveryUnit = unit => {
    this.setState({
      enrolledUnits: this.state.enrolledUnits
        .filter(
          enrolledUnit =>
            !(
              unit.unitCode === enrolledUnit.unitCode &&
              unit.unitAvailabilityYear === enrolledUnit.unitAvailabilityYear &&
              unit.unitAvailabilityLocationCode === enrolledUnit.unitAvailabilityLocationCode &&
              unit.unitAvailabilityStudyPeriodCode === enrolledUnit.unitAvailabilityStudyPeriodCode
            )
        )
        .concat(unit)
    })
  }

  getDropDateText = () => {
    const hasDropDate = this.getActiveEnrolledUnits().some(
      unit => (unit.unitStatus === UnitStatus.PLANNED || unit.unitStatus === UnitStatus.ENROLLED) && new Date(unitWithdrawalDate(unit)) < unitLocationStartDate(unit)
    )

    return (
      hasDropDate && (
        <Sidenote>
          <div>
            <p>
              <strong>Important: </strong> Your enrolment contains at least one unit which has an early online withdraw deadline (noted below those units). If the deadline has passed, you
              will require college approval to make any amendment to those units. All other units follow the relevant study period Census dates. Refer to{' '}
              <a href="https://www.vu.edu.au/current-students/your-course/enrolment/change-your-enrolment/add-or-drop-units" target=" _blank">
                Enrolment Guidelines
              </a>
              .
            </p>
          </div>
        </Sidenote>
      )
    )
  }

  setEnrolmentGuideStudyPackages = studyPackages => {
    this.setState({
      studyPackages: studyPackages
    })
  }

  setEnrolmentGuideLoading = loadingEnrolmentGuide => {
    this.setState({
      loadingEnrolmentGuide: loadingEnrolmentGuide,
      reloadEnrolmentGuide: false
    })
  }

  render() {
    if (this.state.enrolmentApiFailed) {
      return (
        <div className="sidenote sidenote--error">
          <div className="sidenote__content">
            <p>
              There seems to be an issue retrieving your data, please retry. Please{' '}
              <a href="https://www.vu.edu.au/contact-us" target="_blank">
                contact VUHQ
              </a>{' '}
              if you require assistance.
            </p>
          </div>
        </div>
      )
    } else if (!this.state.loadingUnits) {
      if (this.state.apiCallFailed) {
        return (
          <div className="sidenote sidenote--error">
            <div className="sidenote__content">
              <p>
                There seems to be an issue retrieving your data, please retry. Please{' '}
                <a href="https://www.vu.edu.au/contact-us" target="_blank">
                  contact VUHQ
                </a>{' '}
                if you require assistance.
              </p>
            </div>
          </div>
        )
      } else if (isStudentOnLeave()) {
        return (
          <div className="sidenote sidenote--error">
            <div className="sidenote__content">
              <p>
                You have a current Leave of Absence record for this course, changes cannot be made to your enrolment during this time. Please{' '}
                <a href="https://www.vu.edu.au/contact-us" target="_blank">
                  contact VUHQ
                </a>{' '}
                if you require assistance.
              </p>
            </div>
          </div>
        )
      } else if (getAttributeCourseStaticInfo('isStudyPlanExpanded') !== 'Y') {
        return (
          <div className="sidenote sidenote--error">
            <div className="sidenote__content">
              <p>
                Your study plan is not ready for enrolment. Please{' '}
                <a href="https://www.vu.edu.au/contact-us" target="_blank">
                  contact VUHQ
                </a>{' '}
                to discuss your enrolment.
              </p>
            </div>
          </div>
        )
      } else {
        return (
          <div className="page page__home page_fullWidth">
            <Prompt
              message={location => {
                if (this.hasUnconfirmedUnits() || this.hasRemovedUnits()) {
                  switch (location.pathname) {
                    case getConfiguration('baseUrl') + '/units':
                    case getConfiguration('baseUrl') + '/units/add':
                    case getConfiguration('baseUrl') + '/thankyou':
                      return true
                    default:
                      if (this.hasRemovedUnits()) {
                        return this.getRemovedNavigateAwayText()
                      } else {
                        return this.getUnconfirmedNavigateAwayText()
                      }
                  }
                }

                return true
              }}
            />

            {
              <div className="info-link">
                <p>
                  <Info className="btn-point-events" />{' '}
                  <button className="btn-link course-plan-btn" onClick={() => this.setState({ showInfoModal: true })}>
                    Find your Course Delivery Plan
                  </button>
                </p>
              </div>
            }
            <UnitSelectionInstructions
              loading={this.state.loadingUnits}
              blockStatus={this.getIsBlockStatusStudent()}
              defaultLocation={this.state.defaultLocation}
              loadingUnits={this.state.loadingUnits}
              prefillAttemptSuccessful={this.state.prefillAttemptSuccessful}
              enrolledUnits={this.getActiveEnrolledUnits()}
              admissionCategory={this.state.admissionCategory}
              citizenshipCode={this.state.personalDetails ? this.state.personalDetails.stuCitizenCd : null}
              unspecifiedAdvanceStandingFlag={this.state.unspecifiedAdvanceStandingFlag}
            />

            {/*<div className="sidenote sidenote--info">*/}
            {/*<div className="sidenote__content">*/}
            {/*<p><strong>Not sure what units to choose?</strong> All 8 units required to complete year one of your course are included in the blocks below and you can choose the order in which you’ll study them. If you are studying part time, you also have flexibility in how many units you would like to study and in what order, just select from the 8 units available.</p>*/}
            {/*<p><strong>Multiple units offered in one block?</strong> Sometimes VU might offer just one unit in a block (for example, you might be required to study units in a certain order), or VU will offer you several units to choose from. As long as there is availability, you can select any unit from those offered in each block. To provide more flexibility, some units will appear over more than one block but remember - you only need to choose each unit once.</p>*/}
            {/*<p><strong>Still not sure what units to choose?</strong> If you are having trouble deciding on the order of which you’ll study each of your units, you may like to refer to the timetable to select the unit offered at the time that is most suitable to you. If you are looking for more information about your course structure and units, refer to your <a href="https://www.vu.edu.au/current-students/your-course/enrolment/course-delivery-plans" target="_blank">course plan</a>.</p>*/}
            {/*</div>*/}
            {/*</div>*/}
            {this.getDropDateText()}
            {this.getValidationErrors() && (
              <div className="question-group">
                <div className="sidenote sidenote--error">
                  <div className="sidenote__content">
                    {this.getHasDuplicateEnrolledUnits() && <p>You have added the same unit multiple times. Please remove the duplicate units before submitting your enrolment.</p>}
                  </div>
                </div>
              </div>
            )}

            {/* <Encumbrances />*/}

            <ChoiceLines
              choiceLines={this.state.choiceLinesParent}
              selectionRequired={this.state.choiceLinesParent.filter(choiceLine => choiceLine.selectionRequired).length > 0}
              reloadChoiceLineParents={this.reloadChoiceLineParents}
              reOpenModal={this.state.reOpenModal}
            />

            <EnrolmentContainer
              blockStatus={this.getIsBlockStatusStudent()}
              loadingUnits={this.state.loadingUnits}
              loadingEnrolmentGuide={this.state.loadingEnrolmentGuide}
              enrolledUnits={this.getActiveEnrolledUnits()}
              currentEnrolment={this.state.currentEnrolment.filter(
                unit =>
                  (unit.unitStatus === UnitStatus.PLANNED && unit.unitStage === UnitStage.PLANNED) ||
                  (unit.unitStatus === UnitStatus.ENROLLED && unit.unitStage === UnitStage.ENROLLED) ||
                  (unit.unitStatus === UnitStatus.PASS && unit.unitStage === UnitStage.COMPLETED) ||
                  (unit.unitStatus === UnitStatus.FAIL && unit.unitStage === UnitStage.COMPLETED)
              )}
              coursePatternId={this.state.coursePatternId}
              onEnrolmentUpdating={this.handleUpdatingUnits}
              onEnrolmentUpdated={this.onEnrolmentUpdated}
              defaultLocation={this.state.defaultLocation}
              changeUnitUndoState={this.changeUnitUndoState}
              handleChooseDeliveryUnit={this.handleChooseDeliveryUnit}
              prefillAttemptSuccessful={this.state.prefillAttemptSuccessful}
              blockModelStudentPatternApplied={this.state.coursePatternId !== ''}
              //check if we need to pass in the new details - courseYear, advance standing, strict, academicYear, patterns. - academic year and patterns can be used for aligning with continuing use case
              courseYear={this.state.courseYear}
              strictPattern={this.state.strictPatternStudent}
              loadSearchUnits={this.state.coursePatternId !== ''}
              firstPass={true}
              blockMode={this.state.blockCode}
              enrolYear={parseInt(this.state.availabilityYear)}
              studyPackages={this.state.studyPackages}
              dispatchEnrolmentErrorModel={this.dispatchEnrolmentErrorModel}
              studyPeriods={this.state.studyPeriods}
            />
            {this.state.requiresEnrolmentGuide && (
              <EnrolmentGuide
                hasBlockStatus={this.state.hasBlockStatus}
                availabilityYear={parseInt(this.state.availabilityYear)}
                prefillAttemptSuccessful={this.state.prefillAttemptSuccessful}
                firstPass={true}
                setEnrolmentGuideStudyPackages={this.setEnrolmentGuideStudyPackages}
                setEnrolmentGuideLoading={this.setEnrolmentGuideLoading}
                reloadEnrolmentGuide={this.state.reloadEnrolmentGuide}
              />
            )}

            <DrupalModal className="modal-lg" isOpen={this.state.showInfoModal} handleCloseModal={this.handleInfoCloseModal} slug="unit-information" />
            
            <ErrorModal
              title="Updating enrolments failed"
              isOpen={this.state.openEnrolmentErrorModel}
              handleCloseModal={this.handleCloseEnrolmentErrorModal}
              className="modal-xl"
              processErrors="false"
            >
              {processUnitAddErrors(this.state.enrolmentErrors, this.state.enrolmentErrorsPartialSuccess, "put_courses_coursecode_enrolments_general_exception")}
            </ErrorModal>

            <CustomModal
              className={'drop-date-confirmation-modal'}
              isOpen={this.state.showDropDatePassedConfirmationModal}
              userCanClose={true}
              handleCloseModal={this.handleDropDateCloseModal}
              title="Online withdraw deadline has passed"
            >
              <div className="question-group">
                <div className="form-items-group">
                  Your enrolment contains at least one unit with an early online withdraw deadline that has passed. If you proceed, you will be unable to withdraw from those units without
                  college approval.
                </div>
              </div>
              <div className="row">
                <div className="col-xs-6 col-md-6">
                  <button className="btn btn-lg btn-primary" onClick={this.submitDropDateConfirmation}>
                    OK
                  </button>
                </div>
                <div className="col-xs-6 col-md-6">
                  <button className="btn btn-lg btn-primary" onClick={this.handleDropDateCloseModal}>
                    CANCEL
                  </button>
                </div>
              </div>
            </CustomModal>

            <div className="row">
              <div className="col-xs-12 col-md-6">
                <div className="mobile-margin">
                  {this.isLoadingPrefillUnits() && (
                    <button onClick={this.handleSubmit} className="btn btn-lg btn-primary" disabled={this.state.submitting}>
                      {this.state.submitting ? 'Submitting...' : this.getSubmitButtonText()}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )
      }
    } else {
      return <Loading />
    }
  }
}

export default withRouter(Units)
